export const getReservationIdFromConfigId = (configId?: string) => {
  // configId is of form `{companyId}_{pmsReservationId}`, ex. `30926_abcd-1234-efgh`
  const splitIndex = configId?.indexOf('_') ?? -1;
  if (!configId || splitIndex < 0) {
    return undefined;
  }
  return configId.slice(splitIndex + 1) || undefined;
};

export const isGuestVerified = (verificationStatus?: string) => {
  switch (verificationStatus) {
    case 'VERIFIED':
    case 'MANUALLY_VERIFIED':
    case 'OTA_VERIFIED':
      return true;
    case 'NONE':
    case 'PENDING':
    case 'IN_REVIEW':
    case 'MANUALLY_FLAGGED':
    case 'FLAGGED':
    default:
      return false;
  }
};

export const isChekinStepRequired = ({
  enabled,
  isError,
  isLoading,
  chekinStatus,
}: {
  enabled?: boolean;
  isError?: boolean;
  isLoading?: boolean;
  chekinStatus?: string;
}) =>
  Boolean(
    enabled &&
      !isLoading &&
      (isError || (chekinStatus && !isGuestVerified(chekinStatus))),
  );
